
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 53 53","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"icon-fill arrow",attrs:{"fill":"#5ebca8","d":"M31.88 13.12l1.77 1.76-10.06 10.07-6.91-6.91 1.76-1.77 5.15 5.14z"}}),_c('path',{staticClass:"icon-fill",attrs:{"fill":"#5ebca8","d":"M3.59 47.22L7.8 35.16H4.6a4.15 4.15 0 01-4.14-4.14V4.53A4.15 4.15 0 014.6.39h38.3a4.14 4.14 0 014.14 4.14v26.49a4.14 4.14 0 01-4.14 4.14H21.53zm1-44.33a1.65 1.65 0 00-1.63 1.64v26.49a1.65 1.65 0 001.64 1.64h6.73l-2.87 8.3 12.33-8.3H42.9a1.64 1.64 0 001.64-1.64V4.53a1.64 1.64 0 00-1.64-1.64z"}}),_c('path',{staticClass:"icon-fill",attrs:{"fill":"#5ebca8","d":"M49.46 52.61l-18-12.06H21.03v-2.5h11.21l12.33 8.34-2.89-8.3h6.72a1.64 1.64 0 001.64-1.7V7.03h2.5v29.36a4.15 4.15 0 01-4.14 4.14h-3.2z"}})])
          )
        }
      }
    